/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE = 'LinesAggsSorting';

export const SORT_DIRECTION = {
	ASC: 'asc',
	DESC: 'desc',
	NULL: 'null'
};
